var _rect, _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouseMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E34B31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7281 7.73767L10.3011 5.89359C10.205 5.85847 10.1025 5.83744 9.99996 5.83337C9.89579 5.83744 9.79325 5.85643 9.69885 5.89305L5.27177 7.73767C4.98075 7.85974 4.79163 8.14294 4.79163 8.45869V13.9063C4.79163 14.0507 4.90759 14.1667 5.05204 14.1667L6.09371 14.1667C6.23816 14.1667 6.35413 14.0507 6.35413 13.9063V10C6.35413 9.71325 6.59208 9.49385 6.88521 9.49385H13.1157C13.4082 9.4792 13.6458 9.71358 13.6458 10V13.9063C13.6458 14.0507 13.7618 14.1667 13.9062 14.1667L14.9479 14.1667C15.0923 14.1667 15.2083 14.0507 15.2083 13.9063V8.45869C15.2083 8.14294 15.0195 7.85974 14.7281 7.73767Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73955 10.5209H7.13538C6.99378 10.5209 6.87496 10.6397 6.87496 10.7813V11.823C6.87496 11.9662 6.99378 12.0834 7.13538 12.0834H9.73955C9.88196 12.0834 9.99996 11.9654 9.99996 11.823V10.7813C9.99996 10.6397 9.88278 10.5209 9.73955 10.5209ZM9.73946 12.6042H7.13529C6.99369 12.6042 6.87488 12.7231 6.87488 12.8647V13.9063C6.87488 14.0496 6.99369 14.1667 7.13529 14.1667H9.73946C9.88188 14.1667 9.99988 14.0487 9.99988 13.9063V12.8647C9.99988 12.7231 9.88269 12.6042 9.73946 12.6042ZM10.7813 12.6042H12.8646C13.0079 12.6042 13.125 12.7231 13.125 12.8647V13.9063C13.125 14.0487 13.007 14.1667 12.8646 14.1667H10.7813C10.6389 14.1667 10.5209 14.0487 10.5209 13.9063V12.8647C10.5209 12.7223 10.6389 12.6042 10.7813 12.6042Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 24,
    r: 2,
    fill: "#E34B31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseMarker);
export default __webpack_public_path__ + "static/media/warehouse-marker.6e7ec824542f44b6b112984dd2beeea3.svg";
export { ForwardRef as ReactComponent };